import { TQueryDefWrapper } from 'types/network';
import useQueryHookWrapper from '../../../../../hooks/use-query-hook-wrapper';
import { servicesAdmins } from '../../../../../services';
import { QueryConfig } from 'react-query/types/core/types';
import { TGetAdminActivityLogsResponse } from 'types/entities/admin-activity-logs';

const useAdminActivityLogsGet = (
    query: string = '',
    arg0?: QueryConfig<TQueryDefWrapper<TGetAdminActivityLogsResponse>, string>,
) => {
    return useQueryHookWrapper<
        TQueryDefWrapper<TGetAdminActivityLogsResponse>,
        string,
        { query: string }
    >({
        queryKey: 'admin-activity-logs',
        queryFn: servicesAdmins.getAdminActivityLogs,
        queryConfig: arg0,
        values: { query: query },
    });
};

export default useAdminActivityLogsGet;
